/* Native FavouritesScreen: local-first products plus owner-scoped Brands and
   Trends. Public product and lookbook reads enrich the display without
   changing catalogue or customer state. */

(function () {
  var LEGACY_STORAGE_KEY = 'gettmi:favourites:v1';
  var STORAGE_KEY = 'gettmi:favourites:v2';
  var SESSION_KEY = 'gettmi:session:v1';
  var BRAND_PREVIEWS = [
    {
      image: 'https://app.gettmi.com/cdn/shop/collections/2.png?v=1764375553&width=480',
      title: 'ARCINA ORI'
    },
    {
      image: 'https://app.gettmi.com/cdn/shop/collections/1_3a1df8b1-af4f-4f1a-ac53-bf59aad7b05d.png?v=1764375567&width=480',
      title: 'CULT NAKED'
    },
    {
      image: 'https://app.gettmi.com/cdn/shop/collections/3.png?v=1764375579&width=480',
      title: 'RAT & BOA'
    }
  ];
  var productCache = {};
  var favouritesState = {
    brands: [],
    loadId: 0,
    lookbookSlides: [],
    openedFromProfile: false,
    selecting: false,
    selectedSection: null,
    trends: []
  };

  function config() {
    var el = document.querySelector('[data-gettmi-supabase]');
    return el ? { url: String(el.dataset.supabaseUrl || '').replace(/\/+$/, ''), key: el.dataset.supabaseKey } : null;
  }

  function readSession() {
    try {
      var raw = window.localStorage.getItem(SESSION_KEY);
      var session = raw ? JSON.parse(raw) : null;
      if (!session || !session.access_token || !session.user_id) return null;
      if (session.expires_at && session.expires_at * 1000 <= Date.now() + 30000) return null;
      return session;
    } catch (error) {
      return null;
    }
  }

  function authHeaders(cfg, session, extra) {
    return Object.assign({
      apikey: cfg.key,
      Authorization: 'Bearer ' + session.access_token
    }, extra || {});
  }

  function guestStorageKey() {
    return STORAGE_KEY + ':guest';
  }

  function userStorageKey(userId) {
    return STORAGE_KEY + ':user:' + encodeURIComponent(String(userId || ''));
  }

  function activeStorageKey() {
    var session = readSession();
    return session && session.user_id ? userStorageKey(session.user_id) : guestStorageKey();
  }

  function readRawAt(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var data = raw ? JSON.parse(raw) : null;
      return data && typeof data === 'object' ? data : {};
    } catch (error) {
      return {};
    }
  }

  function readAt(key) {
    var data = readRawAt(key);
    return data.items && typeof data.items === 'object' ? data.items : {};
  }

  function writeAt(key, items) {
    try {
      var data = readRawAt(key);
      data.items = items;
      window.localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      /* The current view remains usable when storage is blocked. */
    }
  }

  /* An unheart made while the connection is down never reaches the account. Recording it
     alongside the favourites means the next sync retries it, instead of the account's
     surviving row being pulled back down and the favourite reappearing. */
  function readRemovals() {
    var data = readRawAt(activeStorageKey());
    return data.removals && typeof data.removals === 'object' ? data.removals : {};
  }

  function writeRemovals(removals) {
    try {
      var key = activeStorageKey();
      var data = readRawAt(key);
      data.removals = removals;
      window.localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      /* The removal still applies to this view; only the retry is lost. */
    }
  }

  function rowTime(value) {
    var time = value ? new Date(value).getTime() : 0;
    return Number.isFinite(time) ? time : 0;
  }

  function recordRemoval(handle) {
    if (!handle) return;
    var removals = readRemovals();
    removals[handle] = new Date().toISOString();
    writeRemovals(removals);
  }

  function clearRemoval(handle) {
    var removals = readRemovals();
    if (!handle || !removals[handle]) return;
    delete removals[handle];
    writeRemovals(removals);
  }

  function removeRemoteFavourite(handle, cfg, session) {
    var now = new Date().toISOString();
    return window.fetch(
      cfg.url + '/rest/v1/saved_products?user_id=eq.' + encodeURIComponent(session.user_id) +
        '&product_handle=eq.' + encodeURIComponent(handle),
      {
        method: 'PATCH',
        headers: authHeaders(cfg, session, {
          'Content-Type': 'application/json',
          Prefer: 'return=minimal'
        }),
        body: JSON.stringify({ deleted_at: now, updated_at: now })
      }
    ).then(function (response) {
      if (response.ok) clearRemoval(handle);
      return response.ok;
    }).catch(function () {
      return false;
    });
  }

  function migrateLegacyStorage() {
    try {
      var legacy = window.localStorage.getItem(LEGACY_STORAGE_KEY);
      if (!legacy) return;
      var session = readSession();
      if (!session && !window.localStorage.getItem(guestStorageKey())) {
        window.localStorage.setItem(guestStorageKey(), legacy);
      }
      window.localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (error) {
      /* Never attach ambiguous legacy state to an authenticated owner. */
    }
  }

  function read() {
    migrateLegacyStorage();
    return readAt(activeStorageKey());
  }

  function write(items) {
    writeAt(activeStorageKey(), items);
    paint();
    renderFavourites();
  }

  function prepareForSession(userId) {
    if (!userId) return;
    migrateLegacyStorage();
    var guestKey = guestStorageKey();
    var ownerKey = userStorageKey(userId);
    var guestItems = readAt(guestKey);
    if (Object.keys(guestItems).length) {
      writeAt(ownerKey, Object.assign({}, readAt(ownerKey), guestItems));
      try {
        window.localStorage.removeItem(guestKey);
      } catch (error) {
        /* Owner-scoped reads still prevent cross-account display. */
      }
    }
    paint();
    renderFavourites();
  }

  function clearSessionStorage(userId) {
    try {
      if (userId) window.localStorage.removeItem(userStorageKey(userId));
      window.localStorage.removeItem(guestStorageKey());
      window.localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch (error) {
      /* The rendered state is cleared even when storage is unavailable. */
    }
    paint();
    renderFavourites();
  }

  function persistFavourite(item, cfg, session) {
    if (!item || !item.handle || !cfg || !session) return Promise.resolve(false);
    return window.fetch(cfg.url + '/rest/v1/saved_products?on_conflict=user_id,product_handle', {
      method: 'POST',
      headers: authHeaders(cfg, session, {
        'Content-Type': 'application/json',
        Prefer: 'resolution=merge-duplicates'
      }),
      body: JSON.stringify({
        user_id: session.user_id,
        product_handle: item.handle,
        product_path: item.path,
        product_title: item.title,
        vendor: item.vendor,
        source: 'web',
        deleted_at: null,
        updated_at: new Date().toISOString()
      })
    }).then(function (response) {
      if (response.ok) markSynced(item.handle);
      return response.ok;
    }).catch(function () {
      return false;
    });
  }

  /* Once the account has accepted a favourite, a later "missing from the account" means it
     was unhearted on another device. Without this flag that is indistinguishable from an
     upload that never landed, so the browser re-uploads and undoes the removal. */
  function markSynced(handle) {
    if (!handle) return;
    var items = read();
    if (items[handle] && !items[handle].syncedToAccount) {
      items[handle].syncedToAccount = true;
      write(items);
    }
  }

  function normaliseImage(value) {
    var image = String(value || '');
    return image.indexOf('//') === 0 ? 'https:' + image : image;
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active
      : 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '£' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function view() {
    return document.querySelector('[data-gettmi-favourites-view]');
  }

  function profileView() {
    return document.querySelector('[data-gettmi-settings]');
  }

  function iconUrl() {
    var viewNode = view();
    if (viewNode && viewNode.dataset.favouriteIcon) return viewNode.dataset.favouriteIcon;
    var node = document.querySelector('.gettmi-header-fav img');
    return node && node.src ? node.src : '';
  }

  function setStatus(message) {
    var mount = view();
    var status = mount && mount.querySelector('[data-gettmi-favourites-status]');
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
    window.clearTimeout(setStatus.timer);
    if (message) {
      setStatus.timer = window.setTimeout(function () {
        status.hidden = true;
      }, 2200);
    }
  }

  function paint() {
    var items = read();
    document.querySelectorAll('[data-gettmi-heart]').forEach(function (heart) {
      var active = Boolean(items[heart.dataset.handle]);
      heart.classList.toggle('is-active', active);
      heart.setAttribute('aria-label', active ? 'Remove from favourites' : 'Add to favourites');
      var unsavedLabel = heart.querySelector('[data-gettmi-fave-unsaved]');
      var savedLabel = heart.querySelector('[data-gettmi-fave-saved]');
      if (unsavedLabel) unsavedLabel.hidden = active;
      if (savedLabel) savedLabel.hidden = !active;
    });
  }

  function toggle(heart) {
    var items = read();
    var handle = heart.dataset.handle;
    if (!handle) return;
    var session = readSession();
    /* Saved locally either way. Signed out, it only lives in this browser, so say so
       once rather than letting the list quietly evaporate later. */
    if (!session && !items[handle] && window.GettmiSavePrompt) {
      window.setTimeout(function () {
        window.GettmiSavePrompt.show(
          'Saved to this browser. Create an account to keep your favourites.',
          { once: 'favourites' }
        );
      }, 350);
    }
    var cfg = config();
    var added = false;
    var remoteSave = null;

    if (items[handle]) {
      delete items[handle];
      if (cfg && session) {
        recordRemoval(handle);
        removeRemoteFavourite(handle, cfg, session);
      }
    } else {
      added = true;
      var item = {
        handle: handle,
        path: heart.dataset.path || '/products/' + handle,
        title: heart.dataset.title || '',
        vendor: heart.dataset.vendor || '',
        image: heart.dataset.image || ''
      };
      items[handle] = item;
      if (cfg && session) {
        clearRemoval(handle);
        remoteSave = persistFavourite(item, cfg, session);
      }
    }
    write(items);
    if (!added) return;
    if (session && remoteSave) {
      remoteSave.then(function (confirmed) {
        var latest = readSession();
        if (
          !confirmed ||
          !latest ||
          latest.user_id !== session.user_id
        ) {
          return;
        }
        document.dispatchEvent(new CustomEvent('gettmi:favourite-saved', {
          detail: {
            localConfirmed: true,
            remoteConfirmed: true,
            signedIn: true
          }
        }));
      });
      return;
    }
    document.dispatchEvent(new CustomEvent('gettmi:favourite-saved', {
      detail: {
        localConfirmed: true,
        remoteConfirmed: false,
        signedIn: false
      }
    }));
  }

  function syncFromAccount(options) {
    var cfg = config();
    var session = readSession();
    if (!cfg || !session) return Promise.resolve(false);
    /* A fresh sign-in adopts whatever was hearted while signed out. Every other load treats
       the account as the truth, so an unheart made in the app is not undone by this browser. */
    var freshSignIn = Boolean(options && options.freshSignIn);
    return window.fetch(
      cfg.url + '/rest/v1/saved_products?' +
        'select=product_handle,product_path,product_title,vendor,updated_at&deleted_at=is.null&user_id=eq.' +
        encodeURIComponent(session.user_id),
      { headers: authHeaders(cfg, session) }
    ).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (rows) {
      if (!Array.isArray(rows)) return false;
      var items = read();
      var remoteHandles = {};
      var pending = [];
      var removals = readRemovals();
      rows.forEach(function (row) {
        if (!row.product_handle) return;
        remoteHandles[row.product_handle] = true;

        var removedAt = removals[row.product_handle];
        if (removedAt) {
          if (rowTime(removedAt) >= rowTime(row.updated_at)) {
            pending.push(removeRemoteFavourite(row.product_handle, cfg, session));
            return;
          }
          /* The account has a newer change, so this browser's offline removal is stale. */
          clearRemoval(row.product_handle);
        }

        if (!items[row.product_handle]) {
          items[row.product_handle] = {
            handle: row.product_handle,
            path: row.product_path,
            title: row.product_title,
            vendor: row.vendor,
            image: ''
          };
        }
        items[row.product_handle].syncedToAccount = true;
      });
      /* Favourites the browser holds that the account does not. On a fresh sign-in they are
         the signed-out hearts and belong to the account now. Otherwise one that previously
         reached the account was unhearted elsewhere and goes, while one that never reached
         it is an upload that failed and is retried. */
      Object.keys(items).forEach(function (handle) {
        if (remoteHandles[handle]) return;
        if (freshSignIn || !items[handle].syncedToAccount) {
          pending.push(persistFavourite(items[handle], cfg, session));
          return;
        }
        delete items[handle];
      });
      write(items);
      paint();
      renderFavourites();
      return Promise.all(pending).then(function (results) {
        return results.every(function (result) { return result === true; });
      });
    }).catch(function () {
      return false;
    });
  }

  function displayProducts() {
    var stored = read();
    return Object.keys(stored).map(function (handle) {
      var item = stored[handle];
      var cached = productCache[handle];
      if (!cached || cached.loading) return item;
      return Object.assign({}, item, cached);
    });
  }

  function hydrateProducts(items) {
    var shopRoot = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
    items.forEach(function (item) {
      if (!item.handle || productCache[item.handle] !== undefined) return;
      productCache[item.handle] = { loading: true };
      window.fetch(shopRoot + 'products/' + encodeURIComponent(item.handle) + '.js')
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (product) {
          if (!product) {
            productCache[item.handle] = {};
            return;
          }
          var images = Array.isArray(product.images) ? product.images : [];
          var variants = Array.isArray(product.variants) ? product.variants : [];
          var variant = variants[0] || {};
          productCache[item.handle] = {
            image: normaliseImage(images[0] || product.featured_image || item.image),
            imageModel: normaliseImage(images[1] || images[0] || product.featured_image || item.image),
            price: formatMoney(variant.price || product.price || 0),
            title: product.title || item.title,
            vendor: product.vendor || item.vendor
          };
          renderFavourites();
        })
        .catch(function () {
          productCache[item.handle] = {};
        });
    });
  }

  function publicImageUrl(cfg, row, width, height) {
    var version = row.metadata && row.metadata.asset_version || row.updated_at || row.id || '';
    var path = String(row.image_path || '').split('/').map(encodeURIComponent).join('/');
    var params = [
      'width=' + encodeURIComponent(width || 1200),
      'quality=72',
      'resize=cover'
    ];
    if (height) params.splice(1, 0, 'height=' + encodeURIComponent(height));
    if (version) params.push('v=' + encodeURIComponent(version));
    return cfg.url + '/storage/v1/render/image/public/' +
      encodeURIComponent(row.bucket) + '/' + path + '?' + params.join('&');
  }

  function loadLookbookSlides(cfg, loadId) {
    if (!cfg || !cfg.url || !cfg.key) return;
    window.fetch(
      cfg.url + '/rest/v1/home_campaign_images?' +
        'select=id,surface,bucket,image_path,title,sort_order,metadata,updated_at' +
        '&surface=eq.lookbook&order=sort_order.asc',
      { headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key } }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      return response.json();
    }).then(function (rows) {
      if (loadId !== favouritesState.loadId) return;
      favouritesState.lookbookSlides = (rows || []).filter(function (row) {
        return row.bucket && row.image_path;
      }).map(function (row) {
        return {
          title: row.title || '',
          url: publicImageUrl(cfg, row, 720)
        };
      });
      renderFavourites();
    }).catch(function () {
      if (loadId === favouritesState.loadId) {
        favouritesState.lookbookSlides = [];
        renderFavourites();
      }
    });
  }

  function loadOwnerSections() {
    var cfg = config();
    var session = readSession();
    favouritesState.loadId += 1;
    var loadId = favouritesState.loadId;
    favouritesState.brands = [];
    favouritesState.trends = [];
    favouritesState.lookbookSlides = [];
    renderFavourites();
    loadLookbookSlides(cfg, loadId);

    if (!cfg || !session) return;

    var brandsRequest = window.fetch(
      cfg.url + '/rest/v1/saved_brands?' +
        'select=brand_name,created_at&user_id=eq.' + encodeURIComponent(session.user_id) +
        '&order=created_at.desc',
      { headers: authHeaders(cfg, session) }
    ).then(function (response) {
      return response.ok ? response.json() : [];
    });
    var trendsRequest = window.fetch(
      cfg.url + '/rest/v1/saved_trends?' +
        'select=trend_key,title,source,expires_at,created_at&user_id=eq.' +
        encodeURIComponent(session.user_id) + '&order=created_at.desc',
      { headers: authHeaders(cfg, session) }
    ).then(function (response) {
      return response.ok ? response.json() : [];
    });

    Promise.all([brandsRequest, trendsRequest]).then(function (results) {
      var latest = readSession();
      if (loadId !== favouritesState.loadId || !latest || latest.user_id !== session.user_id) return;
      favouritesState.brands = (results[0] || []).map(function (row) {
        return String(row.brand_name || '').trim();
      }).filter(Boolean);
      favouritesState.trends = (results[1] || []).filter(function (row) {
        if (!row.expires_at) return true;
        return new Date(row.expires_at).getTime() > Date.now();
      });
      renderFavourites();
    }).catch(function () {
      if (loadId !== favouritesState.loadId) return;
      favouritesState.brands = [];
      favouritesState.trends = [];
      renderFavourites();
    });
  }

  function brandPreview(name) {
    return BRAND_PREVIEWS.find(function (preview) {
      return preview.title === name;
    }) || null;
  }

  function displayBrands() {
    return favouritesState.brands.map(function (name) {
      /* No row thumbnail until real brand artwork exists. Only the cover fan still uses
         a preview, and only where one genuinely matches the brand. */
      var preview = brandPreview(name);
      return {
        image: preview ? preview.image : '',
        path: '/collections/vendors?q=' + encodeURIComponent(name),
        title: name
      };
    });
  }

  function trendIndex(row) {
    var match = String(row.trend_key || '').match(/^lookbook-(\d+)$/);
    return match ? Number(match[1]) : null;
  }

  function displayTrends() {
    return favouritesState.trends.map(function (row) {
      var index = trendIndex(row);
      var slide = index === null ? null : favouritesState.lookbookSlides[index];
      if (!slide) return null;
      return {
        image: slide.url,
        index: index,
        meta: row.source === 'lookbook' ? 'Lookbook' : 'Saved edit',
        status: 'Saved to favourites',
        title: row.title || slide.title || 'Lookbook slide ' + (index + 1)
      };
    }).filter(Boolean);
  }

  function sectionData() {
    var products = displayProducts();
    var brands = displayBrands();
    var trends = displayTrends();
    return [
      {
        key: 'trends',
        label: 'Trends',
        subtitle: 'Looks you saved',
        count: trends.length,
        images: trends.map(function (item) { return item.image; })
      },
      {
        key: 'brands',
        label: 'Brands',
        subtitle: 'Brands you love',
        count: brands.length,
        images: brands.map(function (item) { return item.image; })
      },
      {
        key: 'items',
        label: 'Items',
        subtitle: 'Your saved pieces',
        count: products.length,
        images: products.map(function (item) { return item.imageModel || item.image; })
      }
    ];
  }

  function coverStackHtml(images) {
    var visible = images.filter(Boolean).slice(0, 3);
    if (!visible.length) {
      return '<span class="gettmi-favourites-cover__empty">Nothing saved yet</span>';
    }
    var center = Math.floor((visible.length - 1) / 2);
    return (
      '<span class="gettmi-favourites-cover__images">' +
        visible.map(function (image, index) {
          var rotation = (index - center) * 7;
          var zIndex = index === center ? 3 : index + 1;
          return '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" style="' +
            '--gettmi-favourite-rotation:' + rotation + 'deg;z-index:' + zIndex + '">';
        }).join('') +
      '</span>' +
      '<span class="gettmi-favourites-cover__view">View →</span>'
    );
  }

  function coverCardHtml(section, index) {
    return (
      '<button type="button" class="gettmi-favourites-cover__wrap" ' +
        'data-gettmi-favourites-section="' + escapeHtml(section.key) + '" ' +
        'style="--gettmi-favourite-card-index:' + index + ';z-index:' + index + '">' +
        '<span class="gettmi-favourites-cover__card">' +
          '<span class="gettmi-favourites-cover__top">' +
            '<span class="gettmi-favourites-cover__meta">' +
              '<span class="gettmi-favourites-cover__count-icon"></span>' +
              '<span>' + section.count + '</span>' +
            '</span>' +
          '</span>' +
          '<strong>' + escapeHtml(section.label) + '</strong>' +
          '<small>' + escapeHtml(section.subtitle) + '</small>' +
          coverStackHtml(section.images) +
        '</span>' +
      '</button>'
    );
  }

  function renderCover(mount) {
    var stack = mount.querySelector('[data-gettmi-favourites-cover-stack]');
    if (!stack) return;
    stack.classList.remove('is-selecting');
    stack.innerHTML = sectionData().map(coverCardHtml).join('');
  }

  function selectFavouritesSection(section) {
    var mount = view();
    var stack = mount && mount.querySelector('[data-gettmi-favourites-cover-stack]');
    if (!mount || !stack || favouritesState.selecting) return;
    var cards = Array.from(stack.querySelectorAll('[data-gettmi-favourites-section]'));
    var selectedIndex = cards.indexOf(section);
    if (selectedIndex < 0) return;

    favouritesState.selecting = true;
    stack.classList.add('is-selecting');
    cards.forEach(function (card, index) {
      card.classList.toggle('is-selected', index === selectedIndex);
      card.classList.toggle('is-exit-above', index < selectedIndex);
      card.classList.toggle('is-exit-below', index > selectedIndex);
    });

    var finish = function () {
      favouritesState.selecting = false;
      favouritesState.selectedSection = section.dataset.gettmiFavouritesSection;
      renderFavourites();
    };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }
    window.setTimeout(finish, 500);
  }

  function itemDetailHtml(items) {
    if (!items.length) {
      return '<div class="gettmi-favourites-detail__empty">No saved items yet</div>';
    }
    var favouriteIcon = iconUrl();
    return (
      '<div class="gettmi-favourites-detail__block">' +
        '<p class="gettmi-favourites-detail__count">' + items.length + ' saved item' +
          (items.length === 1 ? '' : 's') + '</p>' +
        '<div class="gettmi-favourites-items">' +
          items.map(function (item) {
            var path = item.path || '/products/' + item.handle;
            return (
              '<article class="gettmi-favourites-item">' +
                '<button type="button" class="gettmi-favourites-item__remove gettmi-heart is-active" ' +
                  'data-gettmi-heart data-handle="' + escapeHtml(item.handle) + '" aria-label="Remove from favourites">' +
                  '<img src="' + escapeHtml(favouriteIcon) + '" alt="" width="22" height="22">' +
                '</button>' +
                '<a class="gettmi-favourites-item__media" href="' + escapeHtml(path) + '">' +
                  (item.image
                    ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">'
                    : '<span class="gettmi-placeholder"></span>') +
                '</a>' +
                '<span class="gettmi-favourites-item__vendor">' + escapeHtml(item.vendor || '') + '</span>' +
                '<a class="gettmi-favourites-item__title" href="' + escapeHtml(path) + '">' +
                  escapeHtml(item.title || item.handle) + '</a>' +
                (item.price ? '<p class="gettmi-favourites-item__price">' + escapeHtml(item.price) + '</p>' : '') +
              '</article>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function brandDetailHtml(brands) {
    if (!brands.length) {
      return '<div class="gettmi-favourites-detail__empty">No saved brands yet</div>';
    }
    var favouriteIcon = iconUrl();
    return (
      '<div class="gettmi-favourites-detail__block">' +
        '<p class="gettmi-favourites-detail__count">' + brands.length + ' favourite brand' +
          (brands.length === 1 ? '' : 's') + '</p>' +
        '<div class="gettmi-favourites-rows">' +
          brands.map(function (brand) {
            return (
              '<div class="gettmi-favourites-row">' +
                '<a class="gettmi-favourites-row__open" href="' + escapeHtml(brand.path) + '">' +
                  '<span class="gettmi-favourites-row__copy">' +
                    '<strong>' + escapeHtml(brand.title) + '</strong>' +
                    '<small>New arrivals available</small>' +
                  '</span>' +
                  '<span class="gettmi-favourites-row__chevron">›</span>' +
                '</a>' +
                '<button type="button" class="gettmi-favourites-row__remove" ' +
                  'data-gettmi-remove-favourite-brand="' + escapeHtml(brand.title) + '" ' +
                  'aria-label="Remove ' + escapeHtml(brand.title) + ' from favourites">' +
                  '<img src="' + escapeHtml(favouriteIcon) + '" alt="" width="22" height="22">' +
                '</button>' +
              '</div>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function trendDetailHtml(trends) {
    if (!trends.length) {
      return '<div class="gettmi-favourites-detail__empty">No saved trends yet</div>';
    }
    var favouriteIcon = iconUrl();
    return (
      '<div class="gettmi-favourites-detail__block">' +
        '<p class="gettmi-favourites-detail__count">' + trends.length + ' live trend' +
          (trends.length === 1 ? '' : 's') + '</p>' +
        '<div class="gettmi-favourites-rows">' +
          trends.map(function (trend) {
            return (
              '<div class="gettmi-favourites-row gettmi-favourites-row--trend">' +
                '<button type="button" class="gettmi-favourites-row__open" ' +
                  'data-gettmi-open-favourite-trend="' + trend.index + '">' +
                  '<img class="gettmi-favourites-row__image" src="' + escapeHtml(trend.image) + '" alt="" loading="lazy">' +
                  '<span class="gettmi-favourites-row__copy">' +
                    '<em>' + escapeHtml(trend.meta) + '</em>' +
                    '<strong>' + escapeHtml(trend.title) + '</strong>' +
                    '<small>' + escapeHtml(trend.status) + '</small>' +
                  '</span>' +
                  '<span class="gettmi-favourites-row__chevron">›</span>' +
                '</button>' +
                '<button type="button" class="gettmi-favourites-row__remove" ' +
                  'data-gettmi-remove-favourite-trend="' + trend.index + '" ' +
                  'aria-label="Remove ' + escapeHtml(trend.title) + ' from favourites">' +
                  '<img src="' + escapeHtml(favouriteIcon) + '" alt="" width="22" height="22">' +
                '</button>' +
              '</div>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function renderDetail(mount) {
    var detail = mount.querySelector('[data-gettmi-favourites-detail]');
    if (!detail) return;
    if (favouritesState.selectedSection === 'items') {
      var items = displayProducts();
      detail.innerHTML = itemDetailHtml(items);
      hydrateProducts(items);
      return;
    }
    if (favouritesState.selectedSection === 'brands') {
      detail.innerHTML = brandDetailHtml(displayBrands());
      return;
    }
    detail.innerHTML = trendDetailHtml(displayTrends());
  }

  function renderFavourites() {
    var mount = view();
    if (!mount || mount.hidden) return;
    var cover = mount.querySelector('[data-gettmi-favourites-cover]');
    var detail = mount.querySelector('[data-gettmi-favourites-detail]');
    var title = mount.querySelector('[data-gettmi-favourites-title]');
    var selected = favouritesState.selectedSection;
    title.textContent = selected
      ? selected.charAt(0).toUpperCase() + selected.slice(1)
      : 'Favourites';
    cover.hidden = Boolean(selected);
    detail.hidden = !selected;
    if (selected) renderDetail(mount);
    else {
      renderCover(mount);
      hydrateProducts(displayProducts());
    }
  }

  function openFavourites(section) {
    var mount = view();
    if (!mount) return;
    var profile = profileView();
    favouritesState.openedFromProfile = Boolean(profile && !profile.hidden);
    if (favouritesState.openedFromProfile) profile.hidden = true;
    favouritesState.selecting = false;
    favouritesState.selectedSection = section || null;
    mount.hidden = false;
    document.documentElement.classList.add('gettmi-overlay-open');
    syncFromAccount();
    loadOwnerSections();
    renderFavourites();
    var back = mount.querySelector('[data-gettmi-favourites-close]');
    if (back) back.focus();
  }

  function restoreFavouritesFromTrend() {
    var mount = view();
    if (!mount) return;
    favouritesState.selectedSection = 'trends';
    mount.hidden = false;
    document.documentElement.classList.add('gettmi-overlay-open');
    renderFavourites();
  }

  function closeFavourites() {
    var mount = view();
    if (!mount) return;
    mount.hidden = true;
    favouritesState.selectedSection = null;
    var profile = profileView();
    if (favouritesState.openedFromProfile && profile) {
      profile.hidden = false;
      document.documentElement.classList.add('gettmi-overlay-open', 'gettmi-profile-open');
      var profileOpener = profile.querySelector('[data-gettmi-open-favourites]');
      if (profileOpener) profileOpener.focus();
    } else {
      document.documentElement.classList.remove('gettmi-overlay-open');
      var pageOpener = Array.from(document.querySelectorAll('[data-gettmi-open-favourites]')).find(function (node) {
        return node.getBoundingClientRect().width > 0;
      });
      if (pageOpener) pageOpener.focus();
    }
  }

  function backFavourites() {
    if (favouritesState.selectedSection) {
      favouritesState.selectedSection = null;
      renderFavourites();
      return;
    }
    closeFavourites();
  }

  function removeBrand(name) {
    var cfg = config();
    var session = readSession();
    if (!cfg || !session) {
      setStatus('Sign in from Profile to update favourite brands.');
      return;
    }
    var previous = favouritesState.brands.slice();
    favouritesState.brands = previous.filter(function (item) { return item !== name; });
    renderFavourites();
    window.fetch(
      cfg.url + '/rest/v1/saved_brands?user_id=eq.' + encodeURIComponent(session.user_id) +
        '&brand_name=eq.' + encodeURIComponent(name),
      {
        method: 'DELETE',
        headers: authHeaders(cfg, session, { Prefer: 'return=minimal' })
      }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      setStatus('Removed from favourites');
    }).catch(function () {
      favouritesState.brands = previous;
      renderFavourites();
      setStatus('We could not remove that brand. Try again.');
    });
  }

  function removeTrend(index) {
    var cfg = config();
    var session = readSession();
    if (!cfg || !session) {
      setStatus('Sign in from Profile to update favourite trends.');
      return;
    }
    var key = 'lookbook-' + index;
    var previous = favouritesState.trends.slice();
    favouritesState.trends = previous.filter(function (row) {
      return String(row.trend_key || '') !== key;
    });
    renderFavourites();
    window.fetch(
      cfg.url + '/rest/v1/saved_trends?user_id=eq.' + encodeURIComponent(session.user_id) +
        '&trend_key=eq.' + encodeURIComponent(key),
      {
        method: 'DELETE',
        headers: authHeaders(cfg, session, { Prefer: 'return=minimal' })
      }
    ).then(function (response) {
      if (!response.ok) throw new Error();
      setStatus('Removed from favourites');
    }).catch(function () {
      favouritesState.trends = previous;
      renderFavourites();
      setStatus('We could not remove that trend. Try again.');
    });
  }

  function openTrend(index) {
    var mount = view();
    if (!mount) return;
    if (document.querySelector('[data-gettmi-editorial-surfaces]')) {
      mount.hidden = true;
      document.documentElement.classList.remove('gettmi-overlay-open');
      document.dispatchEvent(new CustomEvent('gettmi:open-saved-trend', {
        detail: { index: index, returnToFavourites: true }
      }));
      return;
    }
    var homeUrl = mount.dataset.homeUrl || '/';
    var target = new URL(homeUrl, window.location.origin);
    target.searchParams.set('gettmi_favourite_trend', String(index));
    window.location.assign(target.toString());
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-gettmi-open-favourites]')) {
      openFavourites();
      return;
    }
    if (event.target.closest('[data-gettmi-favourites-close]')) {
      backFavourites();
      return;
    }
    var section = event.target.closest('[data-gettmi-favourites-section]');
    if (section) {
      selectFavouritesSection(section);
      return;
    }
    var brandRemove = event.target.closest('[data-gettmi-remove-favourite-brand]');
    if (brandRemove) {
      removeBrand(brandRemove.dataset.gettmiRemoveFavouriteBrand);
      return;
    }
    var trendRemove = event.target.closest('[data-gettmi-remove-favourite-trend]');
    if (trendRemove) {
      removeTrend(Number(trendRemove.dataset.gettmiRemoveFavouriteTrend));
      return;
    }
    var trendOpen = event.target.closest('[data-gettmi-open-favourite-trend]');
    if (trendOpen) {
      openTrend(Number(trendOpen.dataset.gettmiOpenFavouriteTrend));
      return;
    }
    var heart = event.target.closest('[data-gettmi-heart]');
    if (!heart) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(heart);
  });

  document.addEventListener('keydown', function (event) {
    var mount = view();
    if (event.key === 'Escape' && mount && !mount.hidden) backFavourites();
  });

  document.addEventListener('gettmi:signed-in', function (event) {
    var session = readSession();
    if (session && session.user_id) prepareForSession(session.user_id);
    if (!event.detail || event.detail.syncManaged !== true) syncFromAccount();
    if (view() && !view().hidden) loadOwnerSections();
  });

  document.addEventListener('gettmi:signed-out', function (event) {
    favouritesState.loadId += 1;
    favouritesState.brands = [];
    favouritesState.trends = [];
    clearSessionStorage(event.detail && event.detail.userId);
  });

  document.addEventListener('gettmi:saved-trend-closed', restoreFavouritesFromTrend);

  window.GettmiFavourites = {
    open: openFavourites,
    paint: paint,
    read: read,
    syncFromAccount: syncFromAccount,
    prepareForSession: prepareForSession,
    clearSessionStorage: clearSessionStorage
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paint();
      syncFromAccount();
    });
  } else {
    paint();
    syncFromAccount();
  }
})();
